import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

export const OnlinePaymentsFeature: FeatureMetadata = {
  id: "online-payments",
  moduleName: "feesFinance",
  navigation: {
    label: "Online Payments",
    path: "/online-payments",
    icon: ArrowPathIcon,
    order: 7,
  },
  route: {
    path: "/online-payments",
    element: lazy(() => import("./pages/OnlinePayments")),
  },
  permissions: buildCrudPermissions("FeeFinance", "OnlinePayments", {
    view: permissionId("FeeFinance", "OnlinePayments", "collectOnline"),
    create: permissionId("FeeFinance", "OnlinePayments", "collectOnline"),
    edit: permissionId("FeeFinance", "OnlinePayments", "reconcile"),
    delete: permissionId("FeeFinance", "OnlinePayments", "refund"),
  }),
  readiness: "live",
};
